export function safeJsonParse<T = unknown>(value?: string): T | null {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
}
